// extracted by mini-css-extract-plugin
export var emailBlockLink = "_pe-0";